
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846021331",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1845",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M494.528 162.304l312.896 257.792v431.488h-620.8V419.648l307.776-257.344M494.08 44.736a32.64 32.64 0 0 0-20.928 7.616L100.416 364.096a32.576 32.576 0 0 0-11.712 25.024v527.808a32.64 32.64 0 0 0 32.64 32.704h751.36a32.64 32.64 0 0 0 32.64-32.704V389.248a32.64 32.64 0 0 0-11.904-25.216L514.88 52.16A32.576 32.576 0 0 0 494.144 44.736z",
        "p-id": "1846",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M355.2 565.76m49.024 0l185.728 0q49.024 0 49.024 49.024l0-0.064q0 49.024-49.024 49.024l-185.728 0q-49.024 0-49.024-49.024l0 0.064q0-49.024 49.024-49.024Z",
        "p-id": "1847",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  